import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getRemovedTokenList } from "../actions/api"
import { setRemovedTokenList, setALLPaginationParamsForRemoved, setRemovedIsMounted } from "../actions/localStates"

import RemovedTokenTab from '../components/RemovedTokenTab';

class RemovedTokenContainer extends Component {

	componentDidMount() {

        if (!this.props.tokenList.isMounted) {
            var searchParams = {
                "uri": this.props.search.uri,
                "removingDateTimeNotBefore": this.props.search.removingDateTimeNotBefore,
                "removingDateTimeNotAfter": this.props.search.removingDateTimeNotAfter,
                "ownerId": this.props.search.ownerId,
                "removingInitiatorId": this.props.search.removingInitiatorId,
                "operator": this.props.search.operator
            }

            var urlParams = "";

            this.props.actions.getRemovedTokenList(this.props.base.serviceUrl, urlParams, searchParams, this.props.login.accessToken)
            .then((response) => {

                if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
                    this.props.actions.setErrorResponse(response.json)
                    this.setState({showErrorPopup: true})
                    return
                }

                this.props.actions.setRemovedTokenList(response.content)
                this.props.actions.setALLPaginationParamsForRemoved(response.page)
                this.props.actions.setRemovedIsMounted(true)

                console.log(response)           
            });
        }
	}

	render() {
		return (
			<RemovedTokenTab />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer,
        search: state.removedTokenSearchReducer,
        tokenList: state.removedTokenListReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    getRemovedTokenList, setRemovedTokenList, setALLPaginationParamsForRemoved,
        setRemovedIsMounted
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovedTokenContainer);